export default __webpack_public_path__ + "static/media/three_of_swords.5c3a4d9e.png";